import { useQuery } from "@tanstack/react-query";
import { UseReceivedBookMonthlyReportQueryOptions } from "./types";
import { getReceivedBookMonthlyReportService } from "./service";

export function useReceivedBookMonthlyReportQuery(
  params?: Record<string, string>,
  options?: UseReceivedBookMonthlyReportQueryOptions
) {
  return useQuery({
    queryKey: ["received_book_admin", "monthly-report", params],
    queryFn: () => getReceivedBookMonthlyReportService(params),
    ...options,
  });
}
